import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

function AdminRoute({ children }) {
  const { currentUser, userProfile } = useAuth();
  if (!currentUser) return <Navigate to="/auth?mode=login" />;
  if (userProfile?.role !== "admin") return <Navigate to="/dashboard" />;
  return children;
}

export default AdminRoute;
